import MultipleSessionApi from '@/api/multipleSession'
import router from '@/router'
import {
  ROUTE_NAMES,
} from '@/constant/routes'
import role from '@/constant/role'

const pendingGetByRootPromise = {}

const actions = {
  publishNewSessionAction: async ({ commit }, payload) => {
    commit('setIsCreatingNewSession', true)
    try {
      await MultipleSessionApi.publishNewSession(payload)
    } finally {
      commit('setIsCreatingNewSession', false)
    }
  },
  getPresentationMasterByPresentationIdAction: async (_, payload) => {
    const resp = await MultipleSessionApi.getPresentationMasterByPresentationId(payload)
    return resp.body
  },
  getListSessionsByPresentationIdAction: async ({ rootGetters }, payload) => {
    let queryParams = {}
    if (rootGetters['multipleSessions/canInvitePresenterToFolder']) {
      queryParams = { batchShareAsPresenter: true }
    }
    const resp = await MultipleSessionApi.getListSessionsByPresentationId(payload, queryParams)
    return resp.body
  },
  getPresentationDetailBySessionAction: async (_, payload) => {
    const res = await MultipleSessionApi.getPresentationDetailBySession(payload)
    res.body.slides = res.body.Slides
    return res
  },
  getRoleForPresentation: async (_, payload) => {
    const { body } = await MultipleSessionApi.getRoleForPresentation(payload)
    return body
  },
  setSelectedSession: async ({ state }, payload) => {
    state.isRenderedReport = false
    state.selectedSession = payload
    if (payload) {
      if (payload.isRoot) {
        state.selectedSession = null
      }
      router.replace({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: payload.presentationId,
        },
      })
    }
    state.isRenderedReport = true
  },
  setDefaultSelectedSession: ({ state }, payload) => {
    state.selectedSession = payload
  },

  getListInstructorByPresentationIdAction: async (_, presentationId) => {
    const resp = await MultipleSessionApi.getListInstructorByPresentationId(presentationId)
    return resp.body.instructors.map((item) => {
      return {
        avatar: item.user.avatar,
        id: item.user.id,
        email: item.user.email,
        firstName: item.user.firstName,
        lastName: item.user.lastName,
        role: role.INSTRUCTOR,
        instructorId: item.instructorId,
      }
    })
  },

  createInstructorAction: async ({ getters }, payload) => {
    const limitedInviteToPresent = getters.canLimitInviteSent
    const params = limitedInviteToPresent ? {
      limitedInviteToPresent,
    } : {}
    if (getters.canInvitePresenterToFolder) {
      params.batchShareAsPresenter = true
    }
    return MultipleSessionApi.createInstructor(payload.presentationId, {
      instructorEmails: payload.collaborators.emails,
    }, params)
  },

  deleteInstructorAction: async (_, payload) => {
    return MultipleSessionApi.deleteInstructor(payload.presentationId, {
      instructorIds: payload.instructorIds,
    })
  },

  fetchMasterPresentationByRootId: async (_, presentationId) => {
    if (!pendingGetByRootPromise[presentationId]) {
      // cache an outgoing request
      // since in presentation list page, both mobile and desktop
      // view exist in parallel, so there are always two same requests
      // this is to de-dup those requests
      pendingGetByRootPromise[presentationId] = MultipleSessionApi.getMasterPresentationByRootId(presentationId)
        .finally(() => {
          delete pendingGetByRootPromise[presentationId]
        })
    }
    const { body } = await pendingGetByRootPromise[presentationId]
    return body
  },
}

export default actions
